// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ModalBody } from 'dibs-elements/exports/ModalBody';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer';

import UpdateInstallDate from './UpdateInstallDate';
import type { UpdateInstallDateProps } from './UpdateInstallDate';

const messages = {
    title: (
        <FormattedMessage
            id="dc.ProjectForms.UpdateInstallDateModal.title"
            defaultMessage="Edit Install Date"
        />
    ),
};

type UpdateInstallDateModalProps = {|
    ...UpdateInstallDateProps,
    isOpen?: boolean,
    onClose: () => void,
|};

export function UpdateInstallDateModal(props: UpdateInstallDateModalProps) {
    const { isOpen, onClose, ...updateInstallProps } = props;

    return (
        <ModalContainer isOpen={!!isOpen} modalPosition="center" onClose={onClose}>
            <BarHeader title={messages.title} />
            <ModalCloseButton onClick={onClose} />
            <ModalBody>
                <UpdateInstallDate {...updateInstallProps} />
            </ModalBody>
        </ModalContainer>
    );
}

export default UpdateInstallDateModal;
